import { h, render } from 'preact';
import values from 'lodash/values';
import Basket from './Basket';
import { DeliveryOption, ExternalBasket } from '../types';

declare global {
    interface Window {
        __BASKET__: ExternalBasket;
        __ORDER_TYPES__: ExternalOrderTypes;
        __DELIVERY_OPTIONS__: Array<DeliveryOption>;
    }
}

export default function(basketTable: HTMLTableElement): void {
    if (window.__BASKET__ === undefined) {
        return;
    }

    const basketContainer = document.getElementById('js-basket') as HTMLDivElement;
    const basket = {
        initialBasketItems: values(window.__BASKET__.items),
        errors: window.__BASKET__.errors,
        surcharges: window.__BASKET__.surcharges,
        subtotal: window.__BASKET__.subtotal,
        subtotalExcludingSurcharges: window.__BASKET__.subtotal_excluding_surcharges,
        subtotalExcludingDelivery: window.__BASKET__.subtotal_excluding_delivery,
        tax: window.__BASKET__.tax,
        taxExcludingDelivery: window.__BASKET__.tax_excluding_delivery,
        total: window.__BASKET__.total,
        orderType: (window.__BASKET__.order_type !== undefined) ? window.__BASKET__.order_type : null,
        orderTypes: window.__ORDER_TYPES__.items,
        deliveryOptions: window.__DELIVERY_OPTIONS__,
        deliveryOption: (window.__BASKET__.delivery_option !== undefined) ? window.__BASKET__.delivery_option : null,
        deliveryPrice: (window.__BASKET__.delivery_price !== undefined) ? window.__BASKET__.delivery_price : null,
        csrfToken: document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') as string,
    };

    basketContainer.innerHTML = '';
    render(<Basket {...basket} />, basketContainer);
}

interface ExternalOrderTypes {
    items: Array<OrderType>;
}

export interface OrderType {
    name: string;
    alias: string;
    due_date: string | null;
    visible: boolean;
    working_days: number;
    day_to_day: boolean;
}
